import React from 'react';
import { useHistory } from 'react-router-dom';
import { Form, DatePicker } from 'antd';
import { PATH } from '../../../routes/Routes';
import { URL_WORKFLOW } from '../../../constance/urls';
import { useTranslation } from 'react-i18next';
import MobileList from '../../common/MobileList';
import { FileTextOutlined, UserOutlined, TruckFilled } from '@ant-design/icons';
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from '../../../constance/strings';
import dayjs from 'dayjs';


export default function WoodImportMobileList() {

  const history = useHistory();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const date = Form.useWatch('produce_date', form);
  const formateDate = date ? dayjs(date).format(DATE_FORMAT) : '';

  const content = {
    header: {
      icon: <FileTextOutlined />,
      detail: (item) => `${t('wood_imports.order_no')}: ${item.wood_import.order_no}`,
    },
    descriptions: [
      {
        icon: <UserOutlined />,
        header: (item) => t('truck_transactions.company'),
        detail: (item) => item.wood_import.truck_company_name
      },
      {
        icon: <TruckFilled />,
        header: (item) => t('trucks.type'),
        detail: (item) => item.wood_import.truck_type_name
      },
    ],
    onClick: (item) => history.push(`${PATH.WOOD_IMPORT}${item.id}`)
  }

  const dateFilterComponent = (
    <Form form={form}>
      <Form.Item label={t('searchs.fields.date')} name={"produce_date"} layout="vertical">
        <DatePicker
          style={{ width: '100%' }}
          format={HUMAN_DATE_FORMAT}
          allowClear
          placeholder={t('searchs.placeholders.date')}
        />
      </Form.Item>
    </Form>
  );

  return (
    <div>
      <MobileList
        ref={tableRef}
        fetchUrl={URL_WORKFLOW.WOOD_IMPORT_WORKFLOW}
        content={content}
        showFilterHeader
        extraFilter={dateFilterComponent}
        extraFilterParams={{ date: formateDate }}
      />
    </div>
  );
}